/*
 * Utility to compare two semver version strings (e.g., 7.0.0-dev-debug, 7.0.0)
 * Returns -1 if a < b, 1 if a > b, 0 if equal
 * @param a First semver string
 * @param b Second semver string
 * @param comparePreRelease Whether to compare pre-release tags (default: true)
 */
export function compareSemver(a: string, b: string, comparePreRelease: boolean = true): number {
    const parse = (v: string) => {
        // Split into [main, preRelease]
        const [main, preRelease] = v.split('-', 2);
        // Split main into numbers
        const mainParts = main.split('.').map(Number);
        return {
            mainParts,
            preRelease: preRelease || '',
        };
    };

    const va = parse(a);
    const vb = parse(b);

    // Compare main version numbers
    for (let i = 0; i < 3; i++) {
        const diff = (va.mainParts[i] || 0) - (vb.mainParts[i] || 0);
        if (diff !== 0) {
            return diff > 0 ? 1 : -1;
        }
    }

    if (!comparePreRelease) {
        return 0;
    }

    // If main parts are equal, compare pre-release
    if (va.preRelease && !vb.preRelease) {
        return -1;
    } // pre-release < release
    if (!va.preRelease && vb.preRelease) {
        return 1;
    } // release > pre-release
    if (va.preRelease && vb.preRelease) {
        // Lexical compare pre-release
        if (va.preRelease < vb.preRelease) {
            return -1;
        }
        if (va.preRelease > vb.preRelease) {
            return 1;
        }
    }
    return 0;
}
